import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout, clearErrors } from "../../../redux/actions/userActions";
import { useNavigate } from "react-router-dom";

import { Notification } from "../../../utils";

const SignOut = ({ isColor }) => {
  const navigate = useNavigate();
  const { error, response } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const handleSignOut = () => {
    dispatch(logout());
    Notification(
      error ? false : true,
      error,
      error ? response : "Logout Successfully"
    );
  };

  console.log("error",error)

  useEffect(() => {
    
    dispatch(clearErrors());
    if (error === false) {
      navigate("/");
    }
  }, [dispatch, navigate]);

  return (
    <button
      className={`dg__btn ${isColor ? "btn--color" : "btn--trans"}`}
      onClick={handleSignOut}
      color={"white"}
    >
      Sign Out
    </button>
  );
};

export default SignOut;
